import React, { useCallback, useReducer } from 'react';
import PropTypes from 'prop-types';

import { actions } from '@atlas/core';

const defaultCasinoFilterState = {
  filter: {
    categories: [],
    providerNames: [],
    name: '',
  },
};

const CasinoFilterContext = React.createContext(defaultCasinoFilterState);
export const useCasinoFilterState = () => React.useContext(CasinoFilterContext);

const categoryReducer = (state, action) => {
  switch (action.type) {
    case actions.FILTER_UPDATE:
      return {
        filter: {
          ...state.filter,
          ...action.payload,
        },
      };
    default:
      return state;
  }
};
const useCasinoFilterStore = initialFilterState => {
  const [state, dispatch] = useReducer(categoryReducer, initialFilterState);

  const updateFilter = useCallback(filter => {
    dispatch({
      type: actions.FILTER_UPDATE,
      payload: filter,
    });
  }, []);

  return {
    ...state,
    updateFilter,
  };
};

export const CasinoFilterProvider = ({ children, initialFilterState }) => {
  const value = useCasinoFilterStore(initialFilterState);

  return <CasinoFilterContext.Provider value={value}>{children}</CasinoFilterContext.Provider>;
};

CasinoFilterProvider.propTypes = {
  children: PropTypes.node,
  initialFilterState: PropTypes.object,
};
